module.exports = __webpack_public_path__ + "static/media/starter-client.9db6ac07.svg";